module.exports = __webpack_public_path__ + "static/media/chef.80717e00.png";